import ResourceLayouts from "layouts/ResourceLayouts";
import { Fragment } from "react";
import Hero from "container/privacy/Hero";
import Content from "container/privacy/Content";
import BuyProxies from "container/home/BuyProxies";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const PrivacyPolicy = () => {
    return (
        <Fragment>
            <ResourceLayouts title="Privacy Policy">
                <Hero />
                <Content />
                <BuyProxies />
            </ResourceLayouts>
        </Fragment>
    );
};

export default PrivacyPolicy;